import Originals from './Originals';

export default Originals;
